import { useState } from 'react';
import { CheckEmail } from './CheckEmail';
import { SendLink } from './SendLink';
import { Box } from '@mui/material';
import { StatusBanner } from '@components';
import { t } from 'i18next';
import { isDev } from '@common/types/utilities.ts';

export const RequestResetPassword = () => {
  const isStaging = isDev();

  const [validData, setValidData] = useState<{
    email: string;
    captcha_id: string;
    captcha_answer: string;
  }>({ email: '', captcha_id: '', captcha_answer: '' });

  const validateEmail = (data: {
    email: string;
    captcha_id: string;
    captcha_answer: string;
  }) => setValidData(data);

  return (
    <>
      {isStaging && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
          }}
        >
          <StatusBanner text={t('general.isStaging')} variant='error' />
        </Box>
      )}
      {validData.email ? (
        <CheckEmail {...validData} validateEmail={validateEmail} />
      ) : (
        <SendLink validateEmail={validateEmail} />
      )}
    </>
  );
};
